import { render } from "./FormTextAreaLabel.vue?vue&type=template&id=1e91a84c"
import script from "./FormTextAreaLabel.vue?vue&type=script&lang=js"
export * from "./FormTextAreaLabel.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__